<template>
  <div class="col-12" style="padding-top: 3em">
    <div class="container">
      <div class="row row-grid align-items-center">
        <div class="col-12">
          <country-flag
            :country="getCityData.iso3"
            size="big"
            class="pull-left mr-2"
          />
          <h2>
            {{ getCityData.city }}
            <small class="text-muted d-block">{{ getCityData.country }}</small>
          </h2>
          <hr style="margin-top: 1em; margin-bottom: 1em" />
        </div>
      </div>

      <div class="row row-grid align-items-center mt-0">
        <div class="col-12">
          <div class="bg-lightgrey country-container">
            <div style="z-index: 1000">
              <ul class="list-unstyled mt-2">
                <li class="py-2">
                  <div class="d-flex align-items-center country-stat">
                    <div>
                      <p class="stat-header font-weight-600 text-uppercase">
                        CFRI Rank
                      </p>
                      <h3 class="mb-0">
                        {{ getCityData.future_readiness_rank }} of 102
                      </h3>
                    </div>
                  </div>
                  <hr class="w-100 mt-3 mb-1 mx-0" />
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center country-stat">
                    <div>
                      <p class="stat-header font-weight-600 text-uppercase">
                        CFRI Score
                      </p>
                      <h6 class="mb-0">
                        {{
                          parseFloat(
                            getCityData.future_readiness_score
                          ).toFixed(2)
                        }}
                      </h6>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center country-stat">
                    <div>
                      <p class="stat-header font-weight-600 text-uppercase">
                        Income Group
                      </p>
                      <h6 class="mb-0">{{ getCityData.income_group }}</h6>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center country-stat">
                    <div>
                      <p class="stat-header font-weight-600 text-uppercase">
                        Regional Group
                      </p>
                      <h6 class="mb-0">{{ getCityData.region }}</h6>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center country-stat">
                    <div>
                      <p class="stat-header font-weight-600 text-uppercase">
                        Population (millions)
                      </p>
                      <h6 class="mb-0">
                        {{
                          parseFloat(getCityData.population / 1000000).toFixed(
                            2
                          )
                        }}
                      </h6>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center country-stat">
                    <div>
                      <p class="stat-header font-weight-600 text-uppercase">
                        GDP Per Capita (US$)
                      </p>
                      <h6 class="mb-0">
                        {{
                          parseFloat(getCityData.gdp_per_capita)
                            .toFixed(2)
                            .toLocaleString()
                        }}
                      </h6>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row row-grid align-items-center">
        <div class="col-12 mt-5 p-0">
          <p class="text-center">Key Performance Indicators</p>
          <div class="row">
            <div class="col-6 mb-3">
              <div class="mobile-pillar-card people_centricity">
                <div class="pillar-name">People Centricity</div>
                <div class="pillar-rank">
                  Rank {{ getCityData.people_centricity_rank }}
                </div>
                <div class="pillar-score">
                  {{ getCityData.people_centricity_score.toFixed(2) }}
                </div>
              </div>
            </div>
            <div class="col-6 mb-3">
              <div class="mobile-pillar-card innovation">
                <div class="pillar-name">Innovation</div>
                <div class="pillar-rank">
                  Rank {{ getCityData.innovation_rank }}
                </div>
                <div class="pillar-score">
                  {{ getCityData.innovation_score.toFixed(2) }}
                </div>
              </div>
            </div>
            <div class="col-6 mb-3">
              <div class="mobile-pillar-card sustainability">
                <div class="pillar-name">Sustainability</div>
                <div class="pillar-rank">
                  Rank {{ getCityData.sustainability_rank }}
                </div>
                <div class="pillar-score">
                  {{ getCityData.sustainability_score.toFixed(2) }}
                </div>
              </div>
            </div>
            <div class="col-6 mb-3">
              <div class="mobile-pillar-card e_intelligence">
                <div class="pillar-name">E-Readiness</div>
                <div class="pillar-rank">
                  Rank {{ getCityData.e_intelligence_rank }}
                </div>
                <div class="pillar-score">
                  {{ getCityData.e_intelligence_score.toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import citiesData from "../../data_2025/cities.json";

export default {
  name: "CityProfileMobile",
  props: {
    selectedCity: {
      type: String,
      default: "san-francisco",
    },
  },
  data() {
    return {
      citiesData: citiesData,
    };
  },
  computed: {
    getCityData() {
      return (
        this.citiesData[this.selectedCity] || this.citiesData["san-francisco"]
      );
    },
  },
};
</script>

<style scoped>
.country-container {
  padding: 1em;
  border-radius: 0.25rem;
}

.country-stat {
  min-height: 50px;
}

.stat-header {
  margin-bottom: 0px;
  font-size: small;
  font-weight: 700 !important;
  color: #4a4a4a !important;
}

.mobile-pillar-card {
  padding: 1rem;
  border-radius: 0.5rem;
  text-align: center;
  color: white;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pillar-name {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.pillar-rank {
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}

.pillar-score {
  font-size: 1.25rem;
  font-weight: 700;
}

.mobile-pillar-card.people_centricity {
  background: #e74c3c;
}

.mobile-pillar-card.innovation {
  background: #3498db;
}

.mobile-pillar-card.sustainability {
  background: #27ae60;
}

.mobile-pillar-card.e_intelligence {
  background: #34495e;
}
</style>
